/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || '${{amount}}';

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      var value = '';

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;

        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, '\'', '.');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;

        case 'amount_no_decimals_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 0, '\'');
          break;
      }

      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    }
document.addEventListener('change', function(e){
  var target = e.target;
  
  if(target.classList.contains('grid-product-form__single-selector')) {
    let _this = {};
    _this.element = target.closest('.product-item');
    let productJsonElement = _this.element.querySelector('[data-product-json]'); // If we are using placeholder, there is no JSON so we wrap here!

    if (productJsonElement) {
      var jsonData = JSON.parse(productJsonElement.innerHTML);
      _this.productData = jsonData['product'];
      _this.variantSelectors = _this.element.querySelectorAll('.product-form__option[data-selector-type]');
      _this.masterSelector = _this.element.querySelector("#product-select-".concat(_this.productData['id'])); // We init value with the first selected variant
      
        _this.option1 = _this.variantSelectors[0] ? _this.variantSelectors[0].querySelector('.product-form__single-selector:checked').value : null;
        _this.option2 = _this.variantSelectors[1] ? _this.variantSelectors[1].querySelector('.product-form__single-selector:checked').value : null;
        _this.option3 = _this.variantSelectors[2] ? _this.variantSelectors[2].querySelector('.product-form__single-selector:checked').value : null;

      let selectedValueElement = target.closest('.product-form__option').querySelector('.product-form__selected-value');

      function getCurrentVariantFromOptions() {

      var found = false;
      _this.productData['variants'].forEach(function (variant) {
        if (variant['option1'] === _this.option1 && variant['option2'] === _this.option2 && variant['option3'] === _this.option3) {
          found = variant;
        }
      });
      return found || null;
    }
    
      if (selectedValueElement) {
        selectedValueElement.innerHTML = target.value;
      } // Finally, we get the new variant

      _this.currentVariant = getCurrentVariantFromOptions();
      let newVariant = _this.currentVariant;

      if (_this.currentVariant) {
        if(_this.masterSelector) {
        _this.masterSelector.querySelector('[selected]').removeAttribute('selected');
        _this.masterSelector.querySelector("[value=\"".concat(_this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
        }
      }

  console.log(_this.currentVariant);

      if (window.theme.showDiscount) {
      let discountLabel = _this.element.querySelector('.product-label--on-sale'); 
      if (discountLabel) {

        if (!newVariant || !(newVariant['price'] < newVariant['compare_at_price'])) {
        discountLabel.style.display = 'none';
      } else {
       
        var savings = null;

        if (window.theme.discountMode === 'percentage') {
          savings = "".concat(Math.round((newVariant['compare_at_price'] - newVariant['price']) * 100 / newVariant['compare_at_price']), "%");
        } else {
          savings = "<span>".concat(formatMoney(newVariant['compare_at_price'] - newVariant['price'], window.theme.moneyFormat), "</span>");
        }

        discountLabel.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace('{{savings}}', savings));
        discountLabel.style.display = 'inline-block';
      }          
      }
      }

      
      _this.primaryImageEl = _this.element.querySelector('.product-item__primary-image');
      if(_this.primaryImageEl) {
        console.log(newVariant.featured_media);
        if(newVariant.featured_media) {
          _this.primaryImageEl.setAttribute('srcset',newVariant.featured_media.preview_image.src);
          _this.primaryImageEl.setAttribute('data-srcset',newVariant.featured_media.preview_image.src);
        }
      }

      
      let productPrices = _this.element.querySelector('.price-list'),
       currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
      if (productPrices) {
      

      if (!newVariant) {
        productPrices.style.display = 'none';
      } else {

        productPrices.innerHTML = '';

        if (newVariant['compare_at_price'] > newVariant['price']) {
          productPrices.innerHTML += "<span class=\"price price--highlight\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(newVariant['price'], currencyFormat), "</span>");
          productPrices.innerHTML += "<span class=\"price price--compare\"><span class=\"visually-hidden\">".concat(window.languages.productRegularPrice, "</span>").concat(formatMoney(newVariant['compare_at_price'], currencyFormat), "</span>");
        } else {
          productPrices.innerHTML += "<span class=\"price\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(newVariant['price'], currencyFormat), "</span>");
        }

        productPrices.style.display = '';
              
      }

      
    }


        let productSku = _this.element.querySelector('.product-meta__sku');
        if (productSku) {
        var productSkuNumber = productSku.querySelector('.product-meta__sku-number');
        if (!newVariant || newVariant['sku'] === '') {
          productSku.style.display = 'none';
        } else {
             productSkuNumber.innerHTML = newVariant['sku'];
          productSku.style.display = '';
          
        }
        }


            let addToCartButtonElement = _this.element.querySelector('.product-item__action-button');
        if (addToCartButtonElement) {
        if (!newVariant) {
          addToCartButtonElement.setAttribute('disabled', 'disabled');
          addToCartButtonElement.classList.add('button--disabled');
          addToCartButtonElement.classList.remove('button--primary');
          addToCartButtonElement.removeAttribute('data-action');
          addToCartButtonElement.innerHTML = window.languages.productFormUnavailable;
        } else {

          if (newVariant['available']) {
            addToCartButtonElement.removeAttribute('disabled');
            addToCartButtonElement.classList.remove('button--disabled');
            addToCartButtonElement.classList.add('button--primary');
            addToCartButtonElement.setAttribute('data-action', 'add-to-cart');
            addToCartButtonElement.innerHTML = this.productTemplate === 'pre-order' ? window.languages.productFormPreOrder : window.languages.productFormAddToCart;
          } else {
            addToCartButtonElement.setAttribute('disabled', 'disabled');
            addToCartButtonElement.classList.add('button--disabled');
            addToCartButtonElement.classList.remove('button--primary');
            addToCartButtonElement.removeAttribute('data-action');
            addToCartButtonElement.innerHTML = window.languages.productFormSoldOut;
          }
        } 
        }

  }
  }
});

